import { THEME_ITAPTEC, type ThemeItaptec } from "./themes/itaptec";
import { THEME_DARK, type ThemeDark } from "./themes/dark";
import { THEME_CUSTOM, type ThemeCustom } from "./themes/custom";
import { THEME_LIQUID_GLASS, type ThemeLiquidGlass } from "./themes/liquidGlass";
import { ThemeName, parseThemeName } from "./ThemeEnum";

const AVAILABLE_THEMES = {
  [ThemeName.ITAPTEC]: THEME_ITAPTEC,
  [ThemeName.DARK]: THEME_DARK,
  [ThemeName.CUSTOM]: THEME_CUSTOM,
  [ThemeName.LIQUID_GLASS]: THEME_LIQUID_GLASS,
} as const;

export type AvailableThemeNames = ThemeName;
export type AnyTheme = ThemeItaptec | ThemeDark | ThemeCustom | ThemeLiquidGlass;


function getConfiguredThemeName(): ThemeName {
  if (typeof window === "undefined") {
    return ThemeName.ITAPTEC;
  }

  const themeName = window.APP_CONFIG?.THEME_NAME;
  return parseThemeName(themeName, ThemeName.ITAPTEC);
}

export { getConfiguredThemeName };


export function getActiveTheme(): AnyTheme {
  const themeName = getConfiguredThemeName();
  return AVAILABLE_THEMES[themeName];
}


export function useTheme(): AnyTheme {
  return getActiveTheme();
}


export function useThemeColors() {
  return getActiveTheme().colors;
}


export function useThemeTypography() {
  return getActiveTheme().typography;
}


export function getAvailableThemes(): Array<{ name: ThemeName; label: string }> {
  return Object.entries(AVAILABLE_THEMES).map(([name, theme]) => ({
    name: name as ThemeName,
    label: theme.label,
  }));
}

export const CURRENT_THEME = getActiveTheme();

export { AVAILABLE_THEMES };














